/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import { NavLink } from "react-router-dom";
import classes from "./css.module.css";
import { connect } from "react-redux";
import Button from "../../component/button";
import { withTranslation } from "react-i18next";
import { useDropzone } from "react-dropzone";
import clsx from "clsx";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const Breadcrumb = (props) => {
  const location = useLocation();
  const {
    list = [],
    className,
    displayImportButton,
    tenantData,
    checkUploadedFile,
    onFilesError,
    t,
  } = props;

  // Dropzone configuration
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: { "application/json": [".json"] },
    maxSize: 10 * 1024 * 1024, // 10 MB
    multiple: false,
    onDropAccepted: (acceptedFiles) => {
      if (acceptedFiles && acceptedFiles.length > 0) {
        checkUploadedFile(acceptedFiles[0]);
      }
    },
    onDropRejected: (fileRejections) => {
      if (onFilesError) {
        onFilesError(fileRejections);
      }
    },
  });
  const getPathBeforeQuery = (url) => {
    if (!url || typeof url !== 'string') return '';
    const index = url.indexOf('?');
    return index !== -1 ? url.substring(0, index) : url;
  }

  return (
    <div className={classes.breadCrumbDiv}>
      <ol className={[classes.ol, className].join(" ")}>
        {list.map((item, index) => (
          <React.Fragment key={index}>
            <li>
              <NavLink
                to={item.url}
                // className={classes.link + ' ' + list.length - 1 === index ? classes.active : ''}
                // className={clsx(classes.link, { [classes.active]: list.length - 1 === index })}
                className={clsx(classes.link, { [classes.active]: getPathBeforeQuery(item.url) === location.pathname })}
                style={{ color: tenantData?.color || "inherit" }}
              >
                {item.title}
              </NavLink>
            </li>
            {index < list.length - 1 && (
              <li className={classes.seperatorClass}>></li>
            )}
          </React.Fragment>
        ))}
      </ol>

      {displayImportButton && (
        <div
          className={classes.importButton}
          {...getRootProps()}
          style={{ cursor: "pointer" }}
        >
          <input {...getInputProps()} />
          <Button>
            {isDragActive ? t("DROP_FILE_HERE") : t("IMPORT_PRODUCT_TEMPLATE")}
          </Button>
        </div>
      )}
    </div>
  );
};

// Redux mappings
const mapStateToProps = (state) => ({
  tenantData: state.auth.tenantData,
});

export default connect(mapStateToProps)(
  withTranslation("translations")(Breadcrumb),
);
